import { getIsRecruitFromCookie, getUserRoleFromCookie } from '~/utils/auth'
import { UserRole } from "~/types/account"
import { stripSubLocalePrefix } from '~/utils/locale'
import { useLocaleStore } from '~/stores/locale'
import { JOIN_ROOT } from '~/utils/joinRoutes'

export default defineNuxtRouteMiddleware((to, _from) => {
  // Allow all /join/* routes. On sub-locale domains (e.g. .ca/fr, .be/de) the
  // lang-guard middleware prefixes the path with the language segment, so a
  // join step arrives here as /fr/join/... — strip that prefix before the
  // check. Otherwise a freshly-registered recruit is treated as "off the join
  // flow" and bounced back to /join on every step, which renders blank. AB#60118.
  if (stripSubLocalePrefix(to.path, useLocaleStore().subLocaleLang).startsWith(JOIN_ROOT)) return

  let recruitDetected = false

  try {
    const { isRecruit, userRole } = useSAuthState()

    if (isRecruit.value) {
      recruitDetected = true
    } else if (userRole.value === UserRole.Anonymous) {
      // Check cookies — server uses httpOnly userRole, client uses isRecruit
      if (import.meta.server) {
        const headers = useRequestHeaders()
        const cookieRole = getUserRoleFromCookie(headers.cookie || '')
        recruitDetected = cookieRole?.toLowerCase() === 'recruit'
      } else if (import.meta.client) {
        recruitDetected = getIsRecruitFromCookie(document.cookie) === 'true'
      }
    }
  } catch {
    return
  }

  if (recruitDetected) {
    return navigateTo(JOIN_ROOT)
  }
})
